import { tenderAIAPi } from './tender-ai-api';
const getAllExpertises = () => {
    return tenderAIAPi.get('expertise');
};
const ExpertiseApi = {
    getAllExpertises
};
export default ExpertiseApi;
